import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import DateTime from '../../helpers/DateTime';
import { Maintenance } from '../../interfaces/Stylesheet';
import Button from '../Button';
import styles from './Maintenance.module.scss';

interface MaintenanceComponentProps {
  maintenance: Maintenance;
}

export const MaintenanceComponent: FunctionComponent<MaintenanceComponentProps> = ({ maintenance }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.component}>
      <h1>{maintenance.title}</h1>
      <p>{maintenance.description}</p>
      <table className={styles.statusTable}>
        <thead>
          <tr>
            {maintenance.startTime && (
              <th dangerouslySetInnerHTML={{ __html: t('errorMaintenance:maintenanceStart') }} />
            )}
            {maintenance.endTime && (
              <th dangerouslySetInnerHTML={{ __html: t('errorMaintenance:maintenanceEnd') }} />
            )}
            <th dangerouslySetInnerHTML={{ __html: t('errorMaintenance:maintenancePurpose') }} />
          </tr>
        </thead>
        <tbody>
          <tr>
            {maintenance.startTime && (
              <td dangerouslySetInnerHTML={{ __html: DateTime.formatDate('d MMMM HH:mm', new Date(maintenance.startTime)) }} />
            )}
            {maintenance.endTime && (
              <td dangerouslySetInnerHTML={{ __html: DateTime.formatDate('d MMMM HH:mm', new Date(maintenance.endTime)) }} />
            )}
            <td dangerouslySetInnerHTML={{ __html: maintenance.reason }} />
          </tr>
        </tbody>
      </table>

      <p>
        <Button
          onClick={(): void => {
            window.location.reload();
          }}
          text={t('errorMaintenance:tryAgainButton')} />
      </p>
    </div>
  );
};
